<div class="serial-stats" *ngIf="result" role="status" data-testId="serial-search-stats">
  <span class="serial-stats__item">
    <span class="serial-stats__value">{{ serials.length | number }}</span> serials
  </span>
  <span class="serial-stats__item serial-stats__item--found">
    <mat-icon fontSet="material-symbols-outlined">check_circle</mat-icon>
    <span class="serial-stats__value">{{ result.matched.length | number }}</span> found
  </span>
  <span class="serial-stats__item serial-stats__item--missing" *ngIf="result.notFound.length">
    <mat-icon fontSet="material-symbols-outlined">cancel</mat-icon>
    <span class="serial-stats__value">{{ result.notFound.length | number }}</span> not found
    <button
      mat-icon-button
      type="button"
      class="serial-stats__download"
      matTooltip="Download the serials not found"
      aria-label="Download the serials not found"
      (click)="downloadNotFound()">
      <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
    </button>
  </span>
  <span class="serial-stats__item" *ngIf="result.alreadyAssigned.length">
    <span class="serial-stats__value">{{ result.alreadyAssigned.length | number }}</span> already assigned
  </span>
</div>
